/**
 * @desc 查询年实际销售计划量
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.YearRequest,
): Promise<defs.StandardReturn<defs.ObjectMap<string, number>>> {
  return defHttp.post({
    url: '/web/sale/year/queryYearActualSale',
    data,
  });
}

export function mock(
  data: defs.YearRequest,
): Promise<defs.StandardReturn<defs.ObjectMap<string, number>>> {
  return defHttp.post({
    url: '/mock/web/sale/year/queryYearActualSale',
    data,
  });
}
